export default __webpack_public_path__ + "static/media/IMG_4564-min.5fa70be1.JPG";